import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import { useAuthStore } from './stores/authStore';
import { initStorageCleanup } from './utils/storageCleanup';
import LoginPage from './pages/login/LoginPage';
import DashboardPageWrapper from './pages/dashboard/DashboardPageWrapper';
import MedicinesPageWrapper from './pages/medicines/MedicinesPageWrapper';
import InventoryPageWrapper from './pages/inventory/InventoryPageWrapper';
import SuppliersPageWrapper from './pages/suppliers/SuppliersPageWrapper';
import CustomersPageWrapper from './pages/customers/CustomersPageWrapper';
import StockInPageWrapper from './pages/stock-in/StockInPageWrapper';
import StockInFormPage from './pages/stock-in/StockInFormPage';
import StockOutPageWrapper from './pages/stock-out/StockOutPageWrapper';
import StockOutFormPage from './pages/stock-out/StockOutFormPage';
import SalePageWrapper from './pages/pos/SalePageWrapper';
import SystemInfoPage from './pages/system/SystemInfoPage';
import DebtsPageWrapper from './pages/debts/DebtsPageWrraper';
import RevenueReportWrapper from './pages/reports/Revenue/RevenueReportWrapper';
import StockInOutReportWrapper from './pages/reports/StockReport/StockinOutReportWrapper';
import ProfitReportWrapper from './pages/reports/ProfitReport/ProfitReportWrapper';
import ExpensesPageWrapper from './pages/expenses/ExpensesPageWrapper';
import UsersPageWrapper from './pages/users/UsersPageWrapper';
import AppLayout from './components/common/AppLayout';
import CustomerPortalPage from './pages/customer-portal/CustomerPortalPage';
import './App.css';


const { Content } = Layout;

const App = React.memo(() => {
  const { isAuthenticated } = useAuthStore();

  // Initialize storage cleanup
  useEffect(() => {
    initStorageCleanup();
  }, []);

  // Portal route doesn't require authentication
  const currentPath = window.location.pathname;
  const isPortalRoute = currentPath.startsWith('/portal/');

  if (!isAuthenticated && !isPortalRoute) {
    return <LoginPage />;
  }

  // Portal page - no layout needed
  if (isPortalRoute) {
    return (
      <Routes>
        <Route path="/portal/:token" element={<CustomerPortalPage />} />
      </Routes>
    );
  }

  // Authenticated routes
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <AppLayout>
      <Content style={{ padding: '0', height: '100%' }}>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPageWrapper />} />
          <Route path="/medicines" element={<MedicinesPageWrapper />} />
          <Route path="/inventory" element={<InventoryPageWrapper />} />
          <Route path="/suppliers" element={<SuppliersPageWrapper />} />
          <Route path="/customers" element={<CustomersPageWrapper />} />
          <Route path="/stock-in" element={<StockInPageWrapper />} />
          <Route path="/stock-in/new" element={<StockInFormPage />} />
          <Route path="/stock-in/edit/:id" element={<StockInFormPage />} />
          <Route path="/stock-out" element={<StockOutPageWrapper />} />
          <Route path="/stock-out/new" element={<StockOutFormPage />} />
          <Route path="/stock-out/edit/:id" element={<StockOutFormPage />} />
          <Route path="/sale" element={<SalePageWrapper />} />
          <Route path="/reports/stock-in-out" element={<StockInOutReportWrapper />} />
          <Route path="/system" element={<SystemInfoPage />} />
          <Route path="/debts" element={<DebtsPageWrapper />} />
          <Route path="/reports/revenue" element={<RevenueReportWrapper />} />
          <Route path="/reports/profit" element={<ProfitReportWrapper />} />
          <Route path="/expenses" element={<ExpensesPageWrapper />} />
          <Route path="/users" element={<UsersPageWrapper />} />
        </Routes>
      </Content>
    </AppLayout>
  );
});

App.displayName = 'App';

export default App; 